import { render, staticRenderFns } from "./ImageRichText.vue?vue&type=template&id=4f9e8678&scoped=true&"
import script from "./ImageRichText.vue?vue&type=script&lang=js&"
export * from "./ImageRichText.vue?vue&type=script&lang=js&"
import style0 from "./ImageRichText.vue?vue&type=style&index=0&id=4f9e8678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e8678",
  null
  
)

export default component.exports